import script from "./FooterInformation.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterInformation.vue?vue&type=script&lang=ts&setup=true"

import "./FooterInformation.vue?vue&type=style&index=0&id=24993d05&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24993d05"]])

export default __exports__